export const TOGGLE_CATEGORY = 'half-pizza.toggle-c';
export const SELECT_PIZZA = 'half-pizza.sp';
export const INIT = 'half-pizza.init';
export const SUBMIT_FORM = 'half-pizza.sf';

export function init(state) {
    return {type: INIT, payload: state};
}

export function selectPizza(pizzaId) {
    return {type: SELECT_PIZZA, payload: pizzaId};
}

export function toggleCategory(categoryId) {
    return {type: TOGGLE_CATEGORY, payload: categoryId};
}
